"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var aggregation_type_policy_1 = require("./aggregation-type-policy");
/**
 * Created by Hayk.Andriasyan on 5/29/2017.
 */
var AggregationType = /** @class */ (function () {
    function AggregationType(aggregationFunction, aggregationPolicy) {
        this._aggregationFunction = aggregationFunction;
        this._aggregationPolicy = aggregationPolicy;
    }
    AggregationType.newInstance = function (aggregationFunction) {
        return new AggregationType(aggregationFunction, aggregation_type_policy_1.AggregationPolicy.ALLOW);
    };
    AggregationType.prototype.getAggregationFunction = function () {
        return this._aggregationFunction;
    };
    AggregationType.prototype.getAggregationPolicy = function () {
        return this._aggregationPolicy;
    };
    return AggregationType;
}());
exports.AggregationType = AggregationType;
//# sourceMappingURL=aggregation-type.js.map